import { render, staticRenderFns } from "./visualizacao-instituicao-cadastrada.vue?vue&type=template&id=ee1f454e&scoped=true&"
import script from "./visualizacao-instituicao-cadastrada.vue?vue&type=script&lang=js&"
export * from "./visualizacao-instituicao-cadastrada.vue?vue&type=script&lang=js&"
import style0 from "./visualizacao-instituicao-cadastrada.vue?vue&type=style&index=0&id=ee1f454e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee1f454e",
  null
  
)

export default component.exports